export default __webpack_public_path__ + "static/media/haval_h6_8.ebfa3418.png";